import type { UserBasicInfo } from "@common/client"

export function personName(user: UserBasicInfo): string {
  return [user.first_name, user.last_name].filter(Boolean).join(" ")
}

export function wasUpdated(record: {
  created_at: string
  updated_at: string
}): boolean {
  return record.updated_at !== record.created_at
}
